module.exports = __webpack_public_path__ + "img/block-768.04174867.jpg";